import api from "@/lib/api";

export async function startCheckout(lookupKey, userId) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
    user_id: userId || null,
  });
  window.location.href = data.checkout_url;
}
